/**
 * A rule to add exports at the end.
 */
export const addExportsRule = {
  re: /[\s\S]*/,
  replacement(match) {
    const e = makeExports(this.exports)
    const s = `${match}${e ? `\n\n${e}` : ''}`
    return s
  },
}

/**
 * Create a `module.exports` assignment.
 * @param {Object<string, string>} exportsMap
 */
export const makeExports = (exportsMap = {}) => {
  const { 'default': def, ...rest } = exportsMap
  const d = def ? `module.exports = ${def}` : ''
  const r = Object.keys(rest).map((k) => {
    const v = exportsMap[k]
    return `module.exports.${k} = ${v}`
  })
  const s = [d, ...r].filter(a => a).join('\n')
  return s
}